export function generateOrderCode() {
  const randomNumber = Math.floor(Math.random() * 900000) + 100000
  const randomString = randomNumber.toString()
  return randomString
}

export function getFormattedDateTwoDaysLater() {
  const today = new Date()
  today.setDate(today.getDate() + 3)
  const day = String(today.getDate()).padStart(2, '0')
  const month = String(today.getMonth() + 1).padStart(2, '0')
  const year = today.getFullYear()

  const formattedDate = `${day}/${month}/${year}`
  return formattedDate
}

export function normalizeAndLowercaseString(str) {
  return str
    .normalize('NFD')
    .replace(/[\u0300-\u036F]/g, '')
    .toLowerCase()
}
